import React from 'react';
import Skeleton from 'components/ui/Skeleton/Skeleton';

export const ProductDetailSkeleton = () => (
  <div className="pdp-container pdp-skeleton-active" aria-hidden="true">
    <div className="pdp-skeleton-top-nav">
      <Skeleton width="150px" height="20px" />
      <Skeleton width="min(240px, 45%)" height="14px" />
    </div>

    <div className="pdp-main-grid pdp-skeleton-grid">
      <div className="pdp-gallery-wrapper pdp-skeleton-gallery">
        <div className="pdp-thumbnails-vertical pdp-skeleton-thumbnails">
          {[1, 2, 3].map((item) => (
            <Skeleton key={`thumb-sk-${item}`} width="75px" height="75px" />
          ))}
        </div>

        <div className="pdp-skeleton-main-image">
          <Skeleton width="100%" height="100%" style={{ borderRadius: '15px' }} />
        </div>
      </div>

      <div className="pdp-info-section pdp-skeleton-info">
        <Skeleton width="30%" height="20px" />
        <Skeleton width="85%" height="45px" />
        <Skeleton width="40%" height="20px" />
        <Skeleton width="100%" height="120px" style={{ borderRadius: '12px' }} />
        <Skeleton width="100%" height="64px" style={{ borderRadius: '12px' }} />
        <Skeleton width="100%" height="104px" style={{ borderRadius: '16px' }} />
      </div>
    </div>
  </div>
);

export default ProductDetailSkeleton;
